import callNative from '../callNative';
import isInKwaiying from '../isInKwaiying';
import getDeviceInfoSync from '../getDeviceInfoSync';
import getAppName from '../getAppName';
// webLogger中已经强依赖，无法懒加载
import * as YodaBridges from '@yoda/bridge';
export default async function () {
    if (isInKwaiying()) {
        const res = await callNative('getInfoFromKwaiYing', {
            params: { infoName: 'all' },
        })
            .then((env) => {
            if (typeof env === 'string') {
                return JSON.parse(env);
            }
            return env;
        })
            .catch(() => ({}));
        return {
            globalId: res.gid,
            appVersion: res.appVersion,
            did: res.did,
            platform: res.os,
            isMobile: true,
            language: res.language,
            kProjectVersion: res.kprojectVersion,
            appName: 'kwaiying',
        };
    }
    const app = getAppName();
    if (app === 'kwai') {
        // @ts-expect-error
        const res = await YodaBridges.invoke('webview.getDeviceInfo', {});
        return {
            // @ts-expect-error
            ...res.data,
            isMobile: true,
            appName: 'kwai',
        };
    }
    return getDeviceInfoSync();
}
